import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { FormElement } from "../types";

interface TextareaInputProps {
  element: FormElement;
  value: string;
  onChange: (value: string) => void;
}

export const TextareaInput = ({ element, value, onChange }: TextareaInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={element.id}>
        {element.title}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      <Textarea
        id={element.id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={element.required}
        className="min-h-[100px]"
      />
    </div>
  );
};